<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>售后管理</el-breadcrumb-item>
      <el-breadcrumb-item>报销汇总</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card aaass">
      <div class="herd">
        <div class="tops riqi">
          <span>日期筛选：</span>
          <el-date-picker v-model="yue" type="month" @change="gettime" value-format="yyyy-MM" placeholder="选择月"></el-date-picker>
        </div>
        <div class="tops">
          <span>报销公司：</span>
          <el-select v-model="company" placeholder="未选择">
            <el-option v-for="item in companis" :key="item.key" :label="item.val" :value="item.key" @click.native="findComp"></el-option>
          </el-select>
        </div>

        <div class="tops">
          <span>费用所属单位：</span>
          <el-select v-model="daqu" placeholder="未选择">
            <el-option v-for="item in orgs" :key="item.key" :label="item.val" :value="item.key" @click.native="chdaqu"></el-option>
          </el-select>
        </div>
        <div class="tops">
          <span>报销人：</span>
          <el-select v-model="userid" placeholder="未选择">
            <el-option v-for="item in renlist" :key="item.key" :label="item.val" :value="item.key" @click.native="choicedrug"></el-option>
          </el-select>
        </div>
        <!-- <div class="tops">
          <el-button size="mini" type="primary" @click="exportJilu">导出页面表格</el-button>
        </div> -->
      </div>

      <el-table :data="tableData" stripe style="width: 100%" :row-style="{ height: '50px' }">
        <el-table-column prop="month" label="报销月份" sortable></el-table-column>
        <el-table-column prop="user" label="报销人"></el-table-column>
        <el-table-column prop="org" label="费用所属单位"></el-table-column>
        <el-table-column prop="project_no" label="项目编号"></el-table-column>
        <el-table-column prop="firm" label="所属公司"></el-table-column>
        <el-table-column prop="sum" label="汇总金额"></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-button size="mini" type="primary" icon="el-icon-search" @click="viewfun(scope.row.data)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <Fenye :page-data="pageData" @newsize="bianzhi" @newpape="bianye" />
    </el-card>
    <!--  弹窗内容-->
    <dia :dialogVisible="dialogVisible" :isAddorEdit="isAddorEdit" :infoObj="infoObj" @handleClose="handleClose" @update="Getlist" />
    <el-dialog class="dialoghuizong" title="汇总详情弹窗" :visible.sync="huizongdialogVisible" width="50%" :before-close="handleClosehuizong">
      <el-table v-if="huizongData.length !== 0" :data="huizongData" stripe style="width: 100%" :row-style="{ height: '50px' }">
        <el-table-column prop="reimburse_time" label="提交时间" sortable></el-table-column>
        <el-table-column prop="reimburse_no" label="报销编号"></el-table-column>
        <el-table-column prop="org_name" label="费用所属单位"></el-table-column>
        <el-table-column prop="project_no" label="项目编号"></el-table-column>
        <el-table-column prop="user" label="报销人"></el-table-column>
        <el-table-column prop="fee_type" label="费用种类"></el-table-column>
        <el-table-column prop="fee_company_name" label="报销公司"></el-table-column>
        <el-table-column prop="amount" label="报销金额(元)"></el-table-column>
        <el-table-column prop="invoice_name" label="是否有发票"></el-table-column>
        <el-table-column prop="detail" label="报销事项"></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-button size="mini" type="primary" icon="el-icon-search" @click="editfun(scope.row.id)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <Fenye :page-data="pageDataHuizong" @newsize="bianzhihuizong" @newpape="bianyehuizong" />
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="cancelfun()">取 消</el-button> -->
        <!-- <el-button type="primary" @keyup.enter.native="addgoto()" @click="addgoto(tantype)">确 定</el-button> -->
        <el-button type="primary" @click="handleClosehuizong">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Fenye from '../../../components/Fenye'
import dia from './components/jiluDialog.vue'
import { GetJiluDetail, GetHuizongList, GetJiluExport, GetJiluSearch } from '../../../api/shouhuo'
export default {
  components: {
    Fenye,
    dia
  },
  data() {
    return {
      dialogVisible: false, // 弹窗控制
      huizongdialogVisible: false, // 弹窗控制
      infoObj: {},
      isAddorEdit: '',
      fa: '',
      feiyong: '',
      company: '',
      daqu: '',
      userid: '',
      renlist: [],
      yue: '',
      tableData: [],
      huizongData: [],
      orgs: [],
      fees: [],
      companis: [],
      bills: [
        {
          key: '',
          val: '全部'
        },
        {
          key: '1',
          val: '有发票'
        },
        {
          key: '0',
          val: '无发票'
        }
      ],
      pageData: {
        // 当前页数
        page: 1,
        // 当前页数上面的数量
        size: 10,
        // 共有多少条
        count: 0
      },
      pageDataHuizong: {
        // 当前页数
        page: 1,
        // 当前页数上面的数量
        size: 10,
        // 共有多少条
        count: 0
      }
    }
  },
  mounted() {
    let date = new Date()
    let fullyear = String(date.getFullYear())
    let fullmonth = String(date.getMonth() + 1)
    if (fullmonth.length === 1) {
      fullmonth = `0${fullmonth}`
    }
    this.yue = `${fullyear}-${fullmonth}`
    this.Getlist()
    this.Getshaixuan()
  },
  methods: {
    handleClosehuizong() {
      this.huizongdialogVisible = false
      this.huizongData = []
    },
    async viewfun(data) {
      this.huizongData = data
      this.pageDataHuizong.count = data.length
      this.huizongdialogVisible = true
    },
    async editfun(id) {
      const { data } = await GetJiluDetail({ reimburse_id: id })
      console.log(data, 'data')
      if (data.code !== 200) {
        return this.$message.error('获取详情失败')
      }
      // return
      let obj = data.data
      obj.id = id
      this.infoObj = JSON.parse(JSON.stringify(obj))

      // 打开弹窗
      this.opentan('edit')
    },
    // 打开弹窗
    opentan(type) {
      this.dialogVisible = true
      this.isAddorEdit = type
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
    },
    chdaqu() {
      console.log(this.daqu)
      this.Getlist()
    },
    findComp() {
      console.log(this.company)
      this.Getlist()
    },
    chdafei() {
      console.log(this.feiyong)
      this.Getlist()
    },
    chdafapiao() {
      console.log(this.fa)
      this.Getlist()
    },
    bianzhi(newSize) {
      // 分页值变化
      this.pageData.size = newSize
      this.Getlist()
    },
    bianye(newPape) {
      // 分页页数变化
      this.pageData.page = newPape
      this.Getlist()
    },
    bianzhihuizong(newSize) {
      // 分页值变化
      this.pageDatahuizong.size = newSize
      // this.Getlist()
    },
    bianyehuizong(newPape) {
      // 分页页数变化
      this.pageDatahuizong.page = newPape
      // this.Getlist()
    },
    // 时间
    gettime(yue) {
      this.Getlist()
    },
    // 选中人
    choicedrug() {
      this.Getlist()
    },
    async Getlist() {
      let param = {
        ...this.pageData,
        month: this.yue,
        user: this.userid,
        proj: this.daqu,
        firm: this.company
      }
      // param.status="2"
      const { data } = await GetHuizongList(param)
      this.pageData.count = data.data.data.length
      let timess = data.data.month
      // this.pageData.page = data.data.page * 1
      data.data.data.map(item => {
        item.month = timess
        item.data.map(item1 => {
          item1.user = item.user
          if (item1.has_bill === 1) {
            item1.invoice_name = '有发票'
          } else {
            item1.invoice_name = '无发票'
          }
        })
      })
      this.tableData = data.data.data
      console.log(this.tableData, 'this.tableData')
      this.getanpostfun(data, '获取')
    },
    async exportJilu() {
      const { data } = await GetJiluExport()
      console.log(data, 'data')
      let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
      // 创建a标签，并隐藏a标签
      let link = document.createElement('a')
      link.style.display = 'none'
      // a标签的href属性指定下载链接
      link.href = url
      //setAttribute() 方法添加指定的属性，并为其赋指定的值
      // 后缀格式.csv/.xsls要和需要和后端返回格式相同，这里以.csv为例
      link.setAttribute('download', '报销记录')
      document.body.appendChild(link)
      link.click()
      // this.renlist = data.data
    },

    async Getshaixuan() {
      const { data } = await GetJiluSearch()
      // console.log(data.data);
      this.orgs = data.data.projs
      // console.log(this.orgs)
      this.fees = data.data.cost_type
      // console.log(this.fees)
      // this.bills = data.data.bills
      this.companis = data.data.firms
      this.renlist = data.data.users
      // console.log(this.bills)
    },

    // 公共方法
    getanpostfun(data, text, fun) {
      if (data.code === 200) {
        this.$message.success(`${text}成功`)
        fun
      } else {
        return this.$message.error(`${text}失败,原因：${data.message}`)
      }
    }
  }
}
</script>

<style>
.herd {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.aaass {
  box-sizing: border-box;
}
.picsya {
  position: relative;
}
.span {
  font-weight: 300;
  position: absolute;
  top: 25px;
  left: 18px;
  color: #545c64;
  font-size: 30px;
  z-index: 10000;
  pointer-events: none;
}
</style>
